import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useTranslation } from "../i18n/I18nContext";
import { listConsumptions } from "../services/consumption";

// Split out of the former ConsumoLayer. Same "hide cadastro from the menu"
// philosophy applied to ListaProdutosLayer: cadastro is only reachable via
// the "Adicionar Consumo" button below (see CadastrarConsumoLayer / App.js
// route `/despesas/consumo/cadastrar`).
const ListaConsumoLayer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [consumptions, setConsumptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedProductId, setExpandedProductId] = useState(null);

  const fetchConsumptions = () => {
    setLoading(true);
    listConsumptions()
      .then((resp) => setConsumptions(resp.data || []))
      .catch(() => toast.error(t("consumo.error.load")))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchConsumptions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const withEntries = consumptions.filter((c) => (c.consumos || []).length > 0);

  return (
    <div className='row gy-4'>
      <ToastContainer />

      <div className='col-12'>
        <div className='card radius-12'>
          <div className='card-body'>
            <div className='d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24'>
              <div>
                <h6 className='mb-4'>{t("consumo.section.list")}</h6>
                <p className='text-secondary-light mb-0 text-sm'>{t("consumo.list.subtitle")}</p>
              </div>
              <button
                type='button'
                className='btn btn-primary-600 d-flex align-items-center gap-2'
                onClick={() => navigate("/despesas/consumo/cadastrar")}
              >
                <Icon icon='ic:baseline-plus' />
                {t("consumo.list.add")}
              </button>
            </div>

            {loading ? (
              <div className='text-center py-40'>{t("global.loading")}</div>
            ) : withEntries.length === 0 ? (
              <div className='alert alert-info mb-0'>{t("consumo.hint.noConsumptions")}</div>
            ) : (
              <div className='table-responsive scroll-sm'>
                <table className='table bordered-table mb-0'>
                  <thead>
                    <tr>
                      <th scope='col' style={{ width: 40 }} />
                      <th scope='col'>{t("consumo.field.product")}</th>
                      <th scope='col'>{t("consumo.col.totalConsumed")}</th>
                      <th scope='col'>{t("consumo.col.currentStock")}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {withEntries.map((c) => (
                      <React.Fragment key={c.produtoId}>
                        <tr
                          role='button'
                          onClick={() => setExpandedProductId(expandedProductId === c.produtoId ? null : c.produtoId)}
                          className={expandedProductId === c.produtoId ? "bg-neutral-50" : ""}
                        >
                          <td>
                            <Icon
                              icon={expandedProductId === c.produtoId ? "ic:round-expand-less" : "ic:round-expand-more"}
                              className='text-secondary-light text-xl'
                            />
                          </td>
                          <td className='fw-semibold text-primary-light'>{c.produto}</td>
                          <td>{c.quantidadeConsumida}</td>
                          <td>{c.quantidadeDisponivel}</td>
                        </tr>
                        {expandedProductId === c.produtoId && (
                          <tr>
                            <td colSpan={4} className='bg-neutral-25 border-top p-0'>
                              <table className='table table-sm mb-0'>
                                <thead>
                                  <tr>
                                    <th>{t("consumo.field.date")}</th>
                                    <th>{t("consumo.field.quantity")}</th>
                                    <th>{t("consumo.field.unitType")}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {c.consumos.map((entry, idx) => (
                                    <tr key={idx}>
                                      <td>{entry.date}</td>
                                      <td>{entry.quantityConsumed}</td>
                                      <td>{entry.unitType === "package" ? t("consumo.unitType.package") : t("consumo.unitType.base")}</td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListaConsumoLayer;
